// src/components/BannerRow.jsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useBanners } from '../context/BannerContext';
import './BannerRow.css';

export default function BannerRow() {
  const { banners, loadBanners } = useBanners();
  const navigate = useNavigate();

  useEffect(() => {
    if (!banners?.length) loadBanners();
  }, [banners?.length, loadBanners]);

  if (!banners?.length) {
    return (
      <div className="bannerrow-wrapper" aria-hidden>
        <div className="bannerrow-scroll">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="banner-card skeleton">
              <div className="skeleton-line w-60" />
              <div className="skeleton-line w-40 mt-6" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <section className="bannerrow-wrapper" aria-label="Explore collections">
      <div className="bannerrow-titlebar">
        <h3 className="bannerrow-title">Explore</h3>
        <div className="bannerrow-hint">Swipe to discover</div>
      </div>

      <div className="bannerrow-scroll" role="list">
        {banners.map((b) => {
          const to = `/marketplace/banner/${b.slug}`;

          // ✅ If we have a custom image, render the image card
          if (b.img) {
            return (
              <div
                key={b.slug}
                role="listitem"
                className="banner-card-img"
                onClick={() => navigate(to)}
                aria-label={b.title}
              >
                <img src={b.img} alt={b.title} />
              </div>
            );
          }

          // 🔁 Fallback to your original text-only banner card
          return (
            <button
              key={b.slug}
              role="listitem"
              className="banner-card"
              style={{ background: b.bg || 'linear-gradient(135deg, #f5f5f7, #ececf3)' }}
              onClick={() => navigate(to)}
              aria-label={`${b.title}: ${b.subtitle}`}
            >
              <div className="banner-card-top">
                <span className="banner-emoji" aria-hidden>
                  {iconForSlug(b.slug)}
                </span>
              </div>
              <div className="banner-card-content">
                <div className="banner-card-title">{b.title}</div>
                <div className="banner-card-sub">{b.subtitle}</div>
              </div>
              <div className="banner-card-cta" aria-hidden>
                View
                <svg className="chev" width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </button>
          );
        })}
      </div>
    </section>
  );
}

function iconForSlug(slug) {
  switch (slug) {
    case 'recent': return '🆕';
    case 'trending': return '🔥';
    case 'sponsored': return '⭐';
    case 'digital': return '💾';
    case 'under-20-pi': return '💸';
    case 'three-day': return '🚚';
    case 'used': return '♻️';
    case 'electronic': return '📧';
    default: return '🛍️';
  }
}
